import axios, { CancelToken } from 'axios'

import { getAPIUrl } from './api'

export interface IPrice {
  quantity: number
  totalDiscount: number
  price: number
  pricePerStickerIncVAT: number
  vatRate: number
  exchangeRate: number
}

export interface IQuantity {
  quantity: number
  totalDiscount: number
  price: number
  pricePerStickerIncVAT: number
}

export interface IPricingCalculatorResponse {
  price: IPrice
  quantities: IQuantity[]

  pricingQuoteId: string
  sku: string
  productId: string

  currency: string
  moq: number
}

export const calculatePrice = (
  productId: number,
  width: number,
  height: number,
  qty: number,
  material: string,
  currency: string,
  shipToCountry: string,
  languageCode: string,
  cancelToken?: CancelToken
) => {
  const params = new URLSearchParams()
  params.set('width', width.toString())
  params.set('height', height.toString())
  params.set('quantity', qty.toString())
  params.set('materialId', material)
  params.set('productId', productId.toString())
  params.set('currencyCode', currency)
  params.set('shipToCountry', shipToCountry)
  params.set('languageCode', languageCode)

  const utmSource = sessionStorage.getItem('utm_source')
  if (utmSource) {
    params.set('utm_source', utmSource)
  }

  return getAPIUrl(`/calc/?${params.toString()}`).then((calcAPIURL) => {
    return axios
      .get<IPricingCalculatorResponse>(calcAPIURL, {
        method: 'GET',
        cancelToken,
      })
      .then(function (response) {
        return response.data
      })
  })
}
